import { make } from "vuex-pathify";
import { fetchData, fetchList } from "../../API/APIFunctions.js";

export default {
  state: {
    bulletin: {
     id: "",
     bulletinType: ""
    },
    user: {
      id: "",
      username: "",
      password: "",
      firstName: "",
      lastName: "",
      isFirstConnexion: false
    },
    customer: {
      id: "",
      name: "",
      regions: [],
      fleetCount: "",
      accountManager: "",
      contractID: "",
      contractType: "",
      contractStatus: "",
      contractStart: "",
      contractEnd: "",
      deliveryCycleStart: "",
      deliveryCycleEnd: ""
    },
    authentToken: {
      value: "",
      type: "",
      duration: ""
    }
  },

  getters: {
    getCurrentUser: state => {
      return state.user;
    },
    getCompiledUsername: state => {
      return state.user.firstName + " " + state.user.lastName;
    },
    getCurrentCustomer: state => {
      return state.customer;
    },
    /*
     * authentToken getters
     */
    getAuthentToken: state => {
      return state.authentToken;
    },
    getAuthentTokenValue: state => {
      return state.authentToken.value;
    },
    getCompiledAuthentTokenValue: state => {
      return "Bearer" + " " + state.authentToken.value;
    },
    getBulletinId: state => {
      return state.bulletin.id;
    },
    getBulletinType: state => {
      return state.bulletin.bulletinType;
    }
  },

  mutations: {
    /*
     * User mutations
     */
    setUserId: (state, id) => {
      state.user.id = id;
    },
    setUserUsername: (state, username) => {
      state.user.username = username;
    },
    setUserPassword: (state, password) => {
      state.user.password = password;
    },
    setUserFirstName: (state, firstName) => {
      state.user.firstName = firstName;
    },
    setUserLastName: (state, lastName) => {
      state.user.lastName = lastName;
    },
    setUserIsFirstConnexion: (state, value) => {
      value = value == "true" ? true : false;
      state.user.isFirstConnexion = value;
    },
    /*
     * Customer mutations
     */
    setCustomerId: (state, id) => {
      state.customer.id = id;
    },
    setCustomerName: (state, name) => {
      state.customer.name = name;
    },
    setCustomerRegions: (state, regions) => {
      state.customer.regions = regions;
    },
    setCustomerFleetCount: (state, fleetCount) => {
      state.customer.fleetCount = fleetCount;
    },
    setCustomerAccountManager: (state, accountManager) => {
      state.customer.accountManager = accountManager;
    },
    setCustomerContractID: (state, contractID) => {
      state.customer.contractID = contractID;
    },
    setCustomerContractType: (state, contractType) => {
      state.customer.contractType = contractType;
    },
    setCustomerContractStatus: (state, contractStatus) => {
      state.customer.contractStatus = contractStatus;
    },
    setCustomerContractStart: (state, contractStart) => {
      state.customer.contractStart = contractStart;
    },
    setCustomerContractEnd: (state, contractEnd) => {
      state.customer.contractEnd = contractEnd;
    },
    setCustomerDeliveryCycleStart: (state, deliveryCycleStart) => {
      state.customer.deliveryCycleStart = deliveryCycleStart;
    },
    setCustomerDeliveryCycleEnd: (state, deliveryCycleEnd) => {
      state.customer.deliveryCycleEnd = deliveryCycleEnd;
    },

    /*
     * authentToken mutations
     */
    setAuthentTokenValue: (state, value) => {
      state.authentToken.value = value;
    },
    setAuthentTokenType: (state, type) => {
      state.authentToken.type = type;
    },
    setAuthentTokenDuration: (state, duration) => {
      state.authentToken.duration = duration;
    },
    setBulletinId: (state, id) => {
      state.bulletin.id = id;
    },
    setBulletinType: (state, bulletinType) => {
      state.bulletin.bulletinType = bulletinType;
    }
  },

  actions: {
    //fetch informations about user and customer considering given user.
    fetchUserAndCustomer(context, value) {
      var customerId = value.c_customerId;
      context.commit("setUserId", value.id);
      context.commit("setUserUsername", value.c_email);
      context.commit("setUserFirstName", value.c_firstName);
      context.commit("setUserLastName", value.c_lastName);
      context.commit("setUserPassword", value.c_password);
      context.commit("setUserIsFirstConnexion", value.c_isFirstConnexion);
      context.commit("setCustomerId", value.c_customerId);
      return fetchData(
        process.env.VUE_APP_BULLETIN_APP_ID,
        process.env.VUE_APP_CUSTOMER_FORM,
        customerId
      ).then(json => {
        var value = json;
        context.commit("setCustomerName", value.name);
        context.commit("setCustomerRegions", value.regions.split(";"));
        context.commit("setCustomerFleetCount", value.fleetCount);
        context.commit("setCustomerAccountManager", value.accountManager);
        context.commit("setCustomerContractID", value.contractID);
        context.commit("setCustomerContractType", value.contractType);
        context.commit("setCustomerContractStatus", value.contractStatus);
        context.commit("setCustomerContractStart", value.contractStart);
        context.commit("setCustomerContractEnd", value.contractEnd);
        context.commit("setCustomerDeliveryCycleStart", value.deliveryCycleStart);
        context.commit("setCustomerDeliveryCycleEnd", value.deliveryCycleEnd);
      });
    },
    //Refresh and store data about contact  associated to the given email and it's customer
    async getContactAndCustomerData(context, login) {
      return fetchList(
        process.env.VUE_APP_BULLETIN_APP_ID,
        "" + process.env.VUE_APP_CONTACT_LIST,
        [process.env.VUE_APP_JOGET_BMT_FILTER_FOR_CONTACT_EMAIL + "=" + login]
      ).then(json => {
        var data = json.data;
        //return context.dispatch("fetchUserAndCustomer", data[0]);
        return context.dispatch("fetchUserAndCustomer", data.find(x=>x.c_email.toLowerCase() === login.toLowerCase()));
      });

    },
    //Set access token value, type and duration with a data coming from authentification service
    setAuthentToken(context, data) {
      context.commit("setAuthentTokenValue", data.value);
      context.commit("setAuthentTokenType", data.type);
      context.commit("setAuthentTokenDuration", data.duration);
    }
  }
};
